import { render, staticRenderFns } from "./PermissionItems.vue?vue&type=template&id=670381fe&scoped=true&"
import script from "./PermissionItems.vue?vue&type=script&lang=js&"
export * from "./PermissionItems.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItems.vue?vue&type=style&index=0&id=670381fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670381fe",
  null
  
)

export default component.exports